import { AddPillButton } from '@wundo/ui';
import type { CalendarMeetingItem } from '@/lib/meetings.ts';
import { m } from '@/paraglide/messages.js';

export interface AgendaJourneyLinkPillProps {
  suggestion: NonNullable<CalendarMeetingItem['journey_suggestion']>;
  onLink: () => void;
}

/**
 * The journey step Wundo suggests for a meeting it already follows. The card's
 * click opens that meeting, so the offer is a button of its own in the kind
 * pill's place, and linking from it keeps the manager on their week.
 */
export function AgendaJourneyLinkPill({
  suggestion,
  onLink,
}: AgendaJourneyLinkPillProps) {
  const offer = m.agenda_journey_suggestion_pill({
    name: suggestion.type_name,
    position: suggestion.step_position,
  });

  return (
    <AddPillButton
      variant='journey'
      title={offer}
      short={m.agenda_journey_suggestion_pill_short({
        position: suggestion.step_position,
      })}
      aria-label={m.agenda_journey_suggestion_link({
        name: suggestion.type_name,
        position: suggestion.step_position,
      })}
      onClick={onLink}
    >
      {offer}
    </AddPillButton>
  );
}
